import type { IconSvgProps } from '../iconProps';

const FileIcon = ({ theme: _theme, ...props }: IconSvgProps) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.7929 2.5H6.75C6.47385 2.5 6.25 2.72385 6.25 3V22.5C6.25 22.7761 6.47385 23 6.75 23H21.25C21.5261 23 21.75 22.7761 21.75 22.5V7.4571C21.75 7.3245 21.6973 7.19732 21.6035 7.10355L17.1465 2.64645C17.0527 2.55268 16.9255 2.5 16.7929 2.5Z"
      fill="white"
      stroke="#949494"
      strokeMiterlimit="10"
    />
    <path
      d="M16.75 2.5V7C16.75 7.27615 16.9739 7.5 17.25 7.5H21.75"
      stroke="#949494"
      strokeMiterlimit="10"
    />
    <path
      d="M4 13.75H15.5C17.433 13.75 19 15.317 19 17.25C19 19.183 17.433 20.75 15.5 20.75H4V13.75Z"
      fill="#949494"
    />
    <path
      d="M6.634 15.4275L6.928 15.0855V17.0535L6.724 16.8675H8.521V17.4075H6.724L6.928 17.2095V19.3125H6.28V14.8875H8.788V15.4275H6.634ZM9.49122 19.3125V14.8875H10.1332V19.3125H9.49122ZM10.9558 19.3125V14.8875H11.6068V19.1145L11.3128 18.7605H13.3198V19.3125H10.9558ZM14.3334 15.4275L14.6274 15.0855V17.0295L14.4714 16.8225H16.1484V17.3625H14.4714L14.6274 17.1555V19.1145L14.3334 18.7725H16.4814V19.3125H13.9734V14.8875H16.4814V15.4275H14.3334Z"
      fill="white"
    />
  </svg>
);

export default FileIcon;
